webpackJsonp([75],{

/***/ "aJIQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/text-block_9518cdb26dc3b6014aa631a5e43c1c21.html";

/***/ }),

/***/ "rOIc":
/***/ (function(module, exports, __webpack_require__) {

var TextBlock = (function () {
    function TextBlock() {
        this.color = this.color || 'white';
        this.size = this.size || 'large';
    }
    return TextBlock;
}());
angular.module('animatronApp.textBlock', []).component('textBlock', {
    bindings: {
        ltTitle: '<?',
        color: '@?',
        size: '@?',
        description: '<?',
        text: '<?',
        buttons: '<?',
    },
    controller: TextBlock,
    templateUrl: __webpack_require__("aJIQ")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/75-257c10c0995a4d25fa59.min.js